import { Spin } from "antd";

export const LoadingSpinner = () => (
  <div className="h-full flex items-center justify-center">
    <Spin tip="Loading" size="large">
    </Spin>
  </div>
);

export const LazyLoadSpinner = () => (
  <div className="h-full flex items-center justify-center">
    <Spin tip="Loading" size="small" fullscreen>
    </Spin>
  </div>
);
